// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"5368b473","146":"aadc26e5","471":"43eda927","630":"b2dd2e84","709":"94b08cf4"}[chunkId] + ".chunk.css";
};